import React from 'react'
import LabeledValue from '../../../../components/common/LabeledValue'
import Loader from '../../../../components/common/Loader'
import { TimeOffRequestDetails, isVacationBid } from '../../../../store/slices/Requestor/timeOffDetailsSlice'
import { useRetractInlineFlow } from '../../../../hooks/useRetractInlineFlow'
import { getVacationBidAwareTableProps } from './vacationBidOverlapDisplay'
import RetractForm from './RetractForm'
import RightPanel from './RightPanel'
import CurrentRequestSection from './CurrentRequestSection'
import HistorySection from './HistorySection'

interface OverriddenViewProps {
  data: TimeOffRequestDetails
  tableRows: any[]
  highlightedDates: string[]
  handlePrint?: () => void

}

/**
 * Renders the overridden request detail view with the inline retract flow.
 */
const OverriddenView: React.FC<OverriddenViewProps> = ({ data, tableRows, highlightedDates, handlePrint }) => {
  const {
    heading,
    isRetractOpen,
    isSubmittingRetract,
    retractSubmitted,
    partialRetract,
    setPartialRetract,
    comments,
    setComments,
    retractError,
    submitRetractRequest,
    openRetract,
    handleCancel,
  } = useRetractInlineFlow({
    defaultHeading: 'Approved Time Off Request (Override)',
    requestId: data.requestId,
    fallbackNuid: data.nuid,
  })

  return (
    <div>
      {isSubmittingRetract && <Loader />}
      <h1 className="h1">{heading}</h1>
      <div className="flex flex-col mobile:gap-4 tablet:gap-6 desktop:gap-8 desktop:flex-row mt-6">
        <div className="flex-1">
          {data.overriddenOn && (
            <div className="mb-4">
              <LabeledValue label="Overridden On" value={data.overriddenOn} />
            </div>
          )}
          {data.overriddenBy && (
            <div className="mb-4">
              <LabeledValue label="Authorized Approver" value={data.overriddenBy} />
            </div>
          )}
          {(data.requestRank != null || isVacationBid(data)) && (
            <div className="mb-4">
              <LabeledValue label="Request Rank" value={data.requestRank == null ? 'NA' : String(data.requestRank)} />
            </div>
          )}
          {data.approverComments !== undefined && (
            <div className="mb-4">
              <LabeledValue label="Approver Comments" value={data.approverComments || '-'} />
            </div>
          )}
          {isRetractOpen && !retractSubmitted && (
            <RetractForm
              partialRetract={partialRetract}
              onPartialRetractChange={setPartialRetract}
              comments={comments}
              onCommentsChange={setComments}
              retractError={retractError}
              isSubmitting={isSubmittingRetract}
              onSubmit={submitRetractRequest}
              onCancel={handleCancel}
            />
          )}
          {!isRetractOpen && !retractSubmitted && (
            <div className="mt-12! flex flex-row gap-1 flex-wrap">
              <button
                className="button -primary"
                style={{ whiteSpace: 'nowrap' }}
                onClick={openRetract}
              >
                Retract Request
              </button>
            </div>
          )}
        </div>
        <RightPanel data={data} handlePrint={handlePrint} />
      </div>
      <hr className="-variation-1 mt-16!" />
      {data.history && data.history.length > 0 && <HistorySection history={data.history} />}
      <CurrentRequestSection {...getVacationBidAwareTableProps(tableRows, isVacationBid(data))} highlightedDates={highlightedDates} />
    </div>
  )
}

export default OverriddenView
